/* eslint-disable */

import { logEvent } from "firebase/analytics";
import React from "react";
import { analytics } from "../../App/Analytics";

import { DownloadOnAppStore } from "../AppStore/DownloadOnAppStore";

import { ItalicsText } from "../../Infrastucture/MissingReact";

import "./Footer.css";
import "./HeaderAndFooter.css";

function Footer() {
  return (
    <div className="Footer">
      <div className="leftCol">
        <div>
          <svg
            id="tawkitName"
            width="102"
            height="27"
            viewBox="0 0 91 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.38538 11.9062V17.8438C7.38538 18.5729 7.51872 19.125 7.78542 19.5C8.07263 19.8542 8.57524 20.0312 9.29327 20.0312C9.53944 20.0312 9.79588 20.0104 10.0626 19.9688C10.3498 19.9271 10.5857 19.8646 10.7703 19.7812L10.8319 23.5312C10.4831 23.6562 10.0421 23.7604 9.50867 23.8437C8.97528 23.9479 8.4419 24 7.90851 24C6.88276 24 6.02113 23.875 5.32363 23.625C4.62612 23.3542 4.06196 22.9792 3.63114 22.5C3.22084 22 2.92338 21.4167 2.73874 20.75C2.55411 20.0625 2.46179 19.3021 2.46179 18.4688V11.9062H0V8.0625H2.43102V3.96875H7.38538V8.0625H10.9857V11.9062H7.38538Z"
              fill="white"
            />
            <path
              d="M21.789 16.8438H21.1428C20.5889 16.8438 20.0247 16.875 19.4503 16.9375C18.8964 16.9792 18.3938 17.0729 17.9425 17.2188C17.5117 17.3646 17.1527 17.5833 16.8654 17.875C16.5782 18.1458 16.4346 18.5104 16.4346 18.9688C16.4346 19.2604 16.4962 19.5104 16.6193 19.7188C16.7629 19.9271 16.9372 20.0938 17.1424 20.2188C17.3475 20.3438 17.5835 20.4375 17.8502 20.5C18.1169 20.5417 18.3733 20.5625 18.6195 20.5625C19.6452 20.5625 20.4248 20.2812 20.9582 19.7188C21.5121 19.1354 21.789 18.3542 21.789 17.375V16.8438ZM12.5265 10.1875C13.4292 9.3125 14.4755 8.65625 15.6653 8.21875C16.8757 7.78125 18.1066 7.5625 19.358 7.5625C20.6504 7.5625 21.7377 7.72917 22.6199 8.0625C23.5225 8.375 24.2508 8.875 24.8047 9.5625C25.3586 10.2292 25.7587 11.0833 26.0048 12.125C26.2715 13.1458 26.4049 14.3646 26.4049 15.7812V23.625H21.789V21.9688H21.6967C21.3069 22.6146 20.712 23.1146 19.9119 23.4687C19.1323 23.8229 18.281 24 17.3578 24C16.7424 24 16.1064 23.9167 15.4499 23.75C14.7934 23.5833 14.1882 23.3125 13.6343 22.9375C13.101 22.5625 12.6599 22.0625 12.3111 21.4375C11.9624 20.8125 11.788 20.0417 11.788 19.125C11.788 18 12.0855 17.0938 12.6804 16.4062C13.2958 15.7188 14.0754 15.1875 15.0191 14.8125C15.9833 14.4375 17.0501 14.1875 18.2194 14.0625C19.3888 13.9375 20.5274 13.875 21.6352 13.875V13.625C21.6352 12.8542 21.3685 12.2917 20.8351 11.9375C20.3017 11.5625 19.6452 11.375 18.8656 11.375C18.1476 11.375 17.4501 11.5312 16.7731 11.8438C16.1166 12.1562 15.5525 12.5313 15.0806 12.9688L12.5265 10.1875Z"
              fill="white"
            />
            <path
              d="M49.0659 23.625H43.9884L40.9727 13.9375H40.9112L37.957 23.625H32.8796L27.5867 8.0625H33.0335L35.6799 17.9062H35.7722L38.5109 8.0625H43.5884L46.4194 17.9062H46.481L49.1582 8.0625H54.3895L49.0659 23.625Z"
              fill="white"
            />
            <path
              d="M72.2096 23.625H65.9628L60.9469 16.1562H60.8546V23.625H55.7771V0H60.8546V14.375H60.9469L65.8397 8.0625H71.9634L66.0551 15.0938L72.2096 23.625Z"
              fill="white"
            />
            <path
              d="M78.9096 3.09375C78.9096 3.48958 78.8275 3.86458 78.6634 4.21875C78.5198 4.55208 78.3146 4.84375 78.048 5.09375C77.8018 5.34375 77.494 5.54167 77.1248 5.6875C76.776 5.83333 76.4068 5.90625 76.017 5.90625C75.1964 5.90625 74.5091 5.63542 73.9552 5.09375C73.4013 4.53125 73.1244 3.86458 73.1244 3.09375C73.1244 2.71875 73.1962 2.36458 73.3398 2.03125C73.4834 1.67708 73.6885 1.375 73.9552 1.125C74.2219 0.875 74.5296 0.677083 74.8784 0.531251C75.2271 0.364584 75.6067 0.28125 76.017 0.28125C76.4068 0.28125 76.776 0.354167 77.1248 0.500001C77.494 0.645834 77.8018 0.84375 78.048 1.09375C78.3146 1.34375 78.5198 1.64583 78.6634 2C78.8275 2.33333 78.9096 2.69792 78.9096 3.09375ZM73.4936 23.625V8.0625H78.5403V23.625H73.4936Z"
              fill="white"
            />
            <path
              d="M87.3996 11.9062V17.8438C87.3996 18.5729 87.533 19.125 87.7997 19.5C88.0869 19.8542 88.5895 20.0312 89.3075 20.0312C89.5537 20.0312 89.8101 20.0104 90.0768 19.9688C90.364 19.9271 90.6 19.8646 90.7846 19.7812L90.8461 23.5312C90.4974 23.6562 90.0563 23.7604 89.5229 23.8437C88.9895 23.9479 88.4561 24 87.9228 24C86.897 24 86.0354 23.875 85.3379 23.625C84.6404 23.3542 84.0762 22.9792 83.6454 22.5C83.2351 22 82.9376 21.4167 82.753 20.75C82.5684 20.0625 82.476 19.3021 82.476 18.4688V11.9062H80.0143V8.0625H82.4453V3.96875H87.3996V8.0625H91V11.9062H87.3996Z"
              fill="white"
            />
          </svg>
          <svg
            id="tawkitLogo"
            width="19"
            height="22"
            viewBox="0 0 19 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.79399 1.71436C7.12233 1.71436 6.47817 1.96265 6.00323 2.40461C5.5283 2.84657 5.26148 3.446 5.26148 4.07103V7.60399C5.26148 8.22902 5.5283 8.82845 6.00323 9.27041C6.47817 9.71238 7.12233 9.96067 7.79399 9.96067C8.46566 9.96067 9.10981 9.71238 9.58475 9.27041C10.0597 8.82845 10.3265 8.22902 10.3265 7.60399V4.07103C10.3265 3.446 10.0597 2.84657 9.58475 2.40461C9.10981 1.96265 8.46566 1.71436 7.79399 1.71436Z"
              fill="white"
            />
            <path
              d="M14.7143 7.01662V8.5992C14.7143 10.0682 13.9918 11.4771 12.7059 12.5159C12.0671 13.0319 11.3152 13.3038 10.4973 13.5795L6.9037 16.8969V13.5795C5.43738 13.4132 4.06751 13.3714 3.00841 12.5159C1.72245 11.4771 1 10.0682 1 8.5992V7.01662M7.79399 1.71436C7.12233 1.71436 6.47817 1.96265 6.00323 2.40461C5.5283 2.84657 5.26148 3.446 5.26148 4.07103V7.60399C5.26148 8.22902 5.5283 8.82845 6.00323 9.27041C6.47817 9.71238 7.12233 9.96067 7.79399 9.96067C8.46566 9.96067 9.10981 9.71238 9.58475 9.27041C10.0597 8.82845 10.3265 8.22902 10.3265 7.60399V4.07103C10.3265 3.446 10.0597 2.84657 9.58475 2.40461C9.10981 1.96265 8.46566 1.71436 7.79399 1.71436Z"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="square"
            />
          </svg>
        </div>
        <div className="FollowButtons">
          <button id="FollowButton">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0)">
                <path
                  d="M15.996 16V15.9994H16V10.1314C16 7.26071 15.382 5.04938 12.026 5.04938C10.4127 5.04938 9.33003 5.93471 8.88803 6.77404H8.84136V5.31738H5.65936V15.9994H8.9727V10.71C8.9727 9.31738 9.2367 7.97071 10.9614 7.97071C12.6607 7.97071 12.686 9.56004 12.686 10.7994V16H15.996Z"
                  fill="#5300DA"
                />
                <path
                  d="M0.264008 5.31799H3.58134V16H0.264008V5.31799Z"
                  fill="#5300DA"
                />
                <path
                  d="M1.92133 0C0.860667 0 0 0.860667 0 1.92133C0 2.982 0.860667 3.86067 1.92133 3.86067C2.982 3.86067 3.84267 2.982 3.84267 1.92133C3.842 0.860667 2.98133 0 1.92133 0V0Z"
                  fill="#5300DA"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
          <form id="FormToStore" action="https://twitter.com/tawkitapp">
            <button
              onClick={() => {
                logEvent(analytics, "goto_twitter", { Platform: "Web" });
              }}
              id="FollowButton"
            >
              <svg
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 2.41887C17.3306 2.7125 16.6174 2.90712 15.8737 3.00162C16.6388 2.54487 17.2226 1.82712 17.4971 0.962C16.7839 1.38725 15.9964 1.68763 15.1571 1.85525C14.4799 1.13413 13.5146 0.6875 12.4616 0.6875C10.4186 0.6875 8.77387 2.34575 8.77387 4.37863C8.77387 4.67113 8.79862 4.95237 8.85938 5.22012C5.7915 5.0705 3.07687 3.60013 1.25325 1.36025C0.934875 1.91263 0.748125 2.54488 0.748125 3.2255C0.748125 4.5035 1.40625 5.63637 2.38725 6.29225C1.79437 6.281 1.21275 6.10888 0.72 5.83775C0.72 5.849 0.72 5.86363 0.72 5.87825C0.72 7.6715 1.99912 9.161 3.6765 9.50412C3.37612 9.58625 3.04875 9.62562 2.709 9.62562C2.47275 9.62562 2.23425 9.61213 2.01038 9.56262C2.4885 11.024 3.84525 12.0984 5.4585 12.1332C4.203 13.1154 2.60888 13.7071 0.883125 13.7071C0.5805 13.7071 0.29025 13.6936 0 13.6565C1.63462 14.7106 3.57188 15.3125 5.661 15.3125C12.4515 15.3125 16.164 9.6875 16.164 4.81175C16.164 4.64862 16.1584 4.49113 16.1505 4.33475C16.8829 3.815 17.4982 3.16587 18 2.41887Z"
                  fill="#5300DA"
                />
              </svg>
            </button>
          </form>
          <button id="FollowButton">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 3H15C15.825 3 16.5 3.675 16.5 4.5V13.5C16.5 14.325 15.825 15 15 15H3C2.175 15 1.5 14.325 1.5 13.5V4.5C1.5 3.675 2.175 3 3 3Z"
                stroke="#5300DA"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16.5 4.5L9 9.75L1.5 4.5"
                stroke="#5300DA"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="copyright">
          <span id="CopyRightTag">© 2021 tawkit</span>
        </div>
      </div>
      <div className="rightCol">
        <span className="RightColFooter" id="Phrase">
          Podcasting, unchained.
        </span>
        <span className="RightColFooter" id="DownloadPhrase">
          A podcasting-inspired
          <br />
          social platform.
        </span>
        <DownloadOnAppStore />
      </div>
    </div>
  );
}
export default Footer;
